<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/participant">Participant</a></li>
              <li class="breadcrumb-item active">Edit Terminal Capabilities</li>
            </ol>
          </div>
          <h4 class="page-title">Edit Participant Terminal Capabilities</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div *ngIf="!!participant" class="card-box">
          <form class="form-horizontal" role="form" autocomplete="off">

            <div class="form-group row">
              <div class="col-2">
                <label for="terminalCapabilities" class="col-form-label">Terminal capabilities</label>
              </div>
              <div *ngIf="!!mapCustomTerminalCapabilities" id="terminalCapabilities" class="col-6">
                <ng-select2 [(ngModel)]="selectedTerminalCapability" [ngModelOptions]="{standalone: true}"
                            [data]="mapCustomTerminalCapabilities"
                            [options]="select2options" placeholder="Terminal capabilities"></ng-select2>
              </div>
              <div class="col-4">
                <button class="btn btn-info waves-effect waves-light" (click)="addTerminalCapabilitiesFields()" type="button">
                  Add Terminal Capabilities<i class="mdi mdi-plus"></i></button>
              </div>
            </div>

            <ng-container *ngIf="terminalCapabilitiesByParticipant && terminalCapabilitiesByParticipant.length > 0">
              <div class="form-group row" *ngFor="let terminalCapabilitiesFields of terminalCapabilitiesByParticipant">

                <div class="col-2">
                  <label for="terminalCapability" class="col-form-label">Terminal capability</label>
                </div>
                <div id="terminalCapability" class="col-2">
                  <ng-select2 [disabled]="true" [(ngModel)]="terminalCapabilitiesFields.terminalCapabilityId"
                              [ngModelOptions]="{standalone: true}"
                              [data]="terminalCapabilities" [options]="select2options" placeholder="Terminal capabilities"></ng-select2>
                </div>

                <div class="col-2">
                  <label for="participantId" class="col-form-label">Participant
                    Id: {{terminalCapabilitiesFields.participantId}}</label>
                </div>
                <div id="participantId" class="col-2">
                  <button class="btn btn-outline-warning  waves-effect waves-light mdi mdi-delete"
                          (click)="determineDeleteDialog(terminalCapabilitiesFields.terminalCapabilityId)" type="button">Delete
                  </button>
                </div>

              </div>
            </ng-container>

            <div class="form-group row" offset-3 col-9 *ngIf="error">
              <div class="col-10">
                <p class="text-danger">{{errorMessage}}</p>
              </div>
            </div>
            <div class="form-group row offset-3 col-9" *ngIf="!!createResult && createResult.success == false">
              <ng-container *ngIf="!!createResult.message">
                <p class="text-danger">{{createResult.message}}</p>
              </ng-container>
            </div>


            <div class="form-group mb-0 justify-content-end row">
              <div class="col-9">
                <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="save()">
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
